<div class="main-content">
  <nz-row>
    <nz-col nzSpan="10">
      <p nz-typography class="nfl-form-label">Query Id</p>
      <p nz-typography>{{ queryRecord?.queryId }}</p>
    </nz-col>

    <nz-col nzSpan="8" nzOffset="1">
      <p nz-typography class="nfl-form-label">Query Name</p>
      <p nz-typography>{{ queryRecord?.name }}</p>
    </nz-col>

    <nz-col nzSpan="4" nzOffset="1">
      <p nz-typography class="nfl-form-label">Query Type</p>
      <p nz-typography>{{ queryRecord?.type }}</p>
    </nz-col>
  </nz-row>

  <nz-row>
    <nz-col nzSpan="24">
      <p class="nfl-form-label">Query Description</p>
      <p nz-typography>{{ queryRecord?.description }}</p>
    </nz-col>
  </nz-row>

  <nz-row>
    <nz-col nzSpan="24">
      <p class="nfl-form-label">Query</p>
      <p nz-typography>
        <app-monaco-editor [ngModel]="queryRecord?.query" [readOnly]="true"></app-monaco-editor>
      </p>
    </nz-col>
  </nz-row>

  <nz-row>
    <nz-col nzSpan="24">
      <p class="nfl-form-label">Validation Logs</p>
      <p nz-typography [nzType]="validationLogs?.errors?.length ? 'danger' : 'success'">
        {{ validationLogs?.message }}
      </p>

      <ng-container *ngIf="validationLogs?.warnings?.length || 0">
        <p nz-typography>Warnings</p>
        <div *ngFor="let warning of validationLogs?.warnings">
          <p nz-typography nzType="warning">
            {{ warning }}
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="validationLogs?.errors?.length || 0">
        <p nz-typography>Errors</p>
        <div *ngFor="let error of validationLogs?.errors">
          <p nz-typography nzType="danger">
            {{ error }}
          </p>
        </div>
      </ng-container>
    </nz-col>
  </nz-row>

  <ng-container *ngIf="queryRecord?.type === 'AGGREGATE' && queryRecord?.syntheticResult === 'SUCCESS'">
    <h3 class="nfl-form-label" nz-typography>Synthetic Results</h3>
    <nz-alert
      nzType="info"
      nzMessage="This synthetic result is generated on dummy data. NOT ACTUAL data"
      nzShowIcon
      class="alert-msg"
    ></nz-alert>
    <app-aggregate-query-result
      [hideMetadata]="true"
      [isSynthetic]="true"
      [queryRecord]="queryRecord"
    ></app-aggregate-query-result>
  </ng-container>
  <!-- Button wrapper -->
  <div nz-row *ngIf="userRole === 'Analyst' || userRole === 'Admin'">
    <nz-form-item class="w100 button-row">
      <button
        nz-button
        nzType="default"
        nzOutline
        (click)="rejectQueryRecord(queryRecord.queryId, rejectReasonModal)"
        *ngIf="canApproveOrReject(queryRecord)"
      >
        Reject
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="approveQueryRecord(queryRecord.queryId)"
        *ngIf="canApproveOrReject(queryRecord)"
      >
        Approve
      </button>
    </nz-form-item>
  </div>
</div>

<ng-template #rejectReasonModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="rejectReason" class="nfl-form-label">Reject Reason</nz-form-label>
      <nz-form-control [nzErrorTip]="rejectReasonErrorTemplate">
        <textarea
          nz-input
          [formControl]="rejectReason"
          nzSize="large"
          id="rejectReason"
          placeholder="Reject Reason"
          appTrimFormInput
          [nzAutosize]="{ minRows: 2, maxRows: 6 }"
          maxlength="500"
        ></textarea>
      </nz-form-control>
      <ng-template #rejectReasonErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the Reject Reason</div>
        <div *ngIf="control?.errors?.['minlength']">
          Reject Reason must be at least
          {{ control?.errors?.['minlength'].requiredLength }} characters long.
        </div>
        <div *ngIf="control?.errors?.['pattern']">Reject Reason should have at least one alphabet.</div>
      </ng-template>
    </nz-form-item>

    <nz-form-item class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="rejectModalRef.close()">Cancel</button>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          [disabled]="!rejectReason.valid"
          (click)="rejectModalRef.triggerOk()"
        >
          Reject
        </button>
      </nz-space>
    </nz-form-item>
  </form>
</ng-template>
